function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { node } from "prop-types";
import classNamesMaker from "classnames";
import { useInView } from "react-intersection-observer";
import { useMenuBar } from "#library/components/MenuBar/MenuBarContext";
import styles from "#library/components/MenuBar/menuBar.module.css";
var MARGIN_RIGHT = 20;
export var MenuBarItem = function MenuBarItem(_ref) {
  var children = _ref.children;
  var _useMenuBar = useMenuBar(),
    parentRef = _useMenuBar.parentRef,
    marginWidth = _useMenuBar.marginWidth;
  var _useInView = useInView({
      /* Number between 0 and 1 indicating the percentage current Element should be visible before triggering. */
      threshold: 1,
      /* Identify the Element whose bounds are treated as the bounding box of the viewport for the element which is the observer's target. */
      root: parentRef,
      rootMargin: "0px -".concat(marginWidth + MARGIN_RIGHT, "px 0px 0px")
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var itemClassNames = classNamesMaker(styles["jds-MenuBar__item"], !inView && styles["jds-MenuBar__item--noVisible"]);
  return /*#__PURE__*/React.createElement("li", {
    ref: ref,
    className: itemClassNames
  }, children);
};
MenuBarItem.propTypes = {
  children: node.isRequired
};